import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

// const baseURL = 'http://localhost:3604/api';

export interface Response {
  type: string;
  msg: string;
}

export interface BookingsResponse extends Response {
  data: Booking[];
}

export interface Booking {}

@Injectable({
  providedIn: 'root',
})
export class APIService {
  constructor(private httpClient: HttpClient) {}

  enviarFormulario(data: any): Observable<any> {
    // console.log(baseURL);

    return this.httpClient.post('/contacto', data);
  }

  makeOrder(data: any): Observable<any> {
    return this.httpClient.post('contacto/order', data);
  }

  makeBooking(data: any): Observable<any> {
    return this.httpClient.post('booking/order', data);
  }

  getSections(type: any, lang: string = 'es'): Observable<any> {
    let params = new HttpParams().set('lang', lang);
    params = params.set('all', true);
    return this.httpClient.get(`section/public/${type}`, { params });
  }
}
